import React, { useEffect, useState } from "react";
import { Chip } from "@mui/material";

const Motion1Widget = ({ widget, onValueUpdate }) => {
  const [isMotion, setIsMotion] = useState(false);

  useEffect(() => {
    if (widget?.items?.$w1) {
      setIsMotion(widget.items.$w1.value === "motion");
    }
  }, [widget]);

  const getStatusText = () => {
    return isMotion ? "motion" : "clear";
  };

  const getChipColor = () => {
    return isMotion ? "secondary" : "default";
  };

  return (
    <Chip
      label={getStatusText()}
      color={getChipColor()}
      variant="contained"
      sx={{
        width: "100%",
        fontWeight: 500,
        fontSize: "0.875rem",
        textTransform: "capitalize",
      }}
    />
  );
};

export default Motion1Widget;
